import { useTheme } from 'styled-components';

import { Divider, Table, Typography } from '../../../../designComponents';
import { useResponsive } from '../../../../hooks/useResponsive';
import { tableData } from '../invoiceData';
import { InvoiceTableStyled } from './style';

const InvoiceTable = () => {
  const theme = useTheme();
  const { isTablet } = useResponsive();
  return (
    <InvoiceTableStyled>
      <Table
        showCheckBox={false}
        tableData={tableData}
        headingBgColor={theme.colors.secondary}
        showMenuIcon={false}
        evenRowBgColor={theme.colors.lighterBackground}
      />
      <div className="notes">
        {!isTablet && <Divider />}
        <div>
          <div className="sub-total">
            <Typography variant="title">Sub Total:</Typography>
            <Typography variant="title">€40.00</Typography>
          </div>
          {isTablet && <Divider />}
          <div>
            <div className="sub-total">
              <Typography variant="title">Total:</Typography>
              <Typography variant="title">€40.00</Typography>
            </div>
          </div>
        </div>
        <div className="notes-data">
          <Typography variant="title" strong>
            NOTES:
          </Typography>
          <Typography>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Harum
            libero, vitae repudiandae minus aliquid expedita aspernatur iure
            mollitia quidem perspiciatis?
          </Typography>
        </div>
      </div>
    </InvoiceTableStyled>
  );
};

export default InvoiceTable;
